<template>
    <c-dialog ref="dialog" width="900" mode="slide" mask-close :button="false" @close="handleClose">

        <!-- 警告提示 -->
        <div class="form-tip warn-tip">
            <i class="tf">&#xe657;</i>
            <span>接单设置会影响自动派单逻辑，请谨慎操作。已失效的历史记录不可变更或删除，生效中的记录不可删除。</span>
        </div>

        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="engineer_id"></c-input>

            <!-- 暂停接单设置 -->
            <c-title>暂停接单</c-title>
            <div class="factory-handle flex">
                <c-button color="main" prepend-icon="tf-add" @click="openPauseEdit(null)">添加暂停接单</c-button>
            </div>
            <c-table ref="pauseTable" border :paging="false" :data="pausePeriods">
                <c-table-column label="序号" width="60">
                    <template #default="{index}">
                        <span>{{index + 1}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="状态" width="90">
                    <template #default="{data}">
                        <span class="status-tag" :class="'status-' + getRecordStatus(data)">{{recordStatusDic[getRecordStatus(data)]}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="开始日期" width="140">
                    <template #default="{data}">
                        <span>{{data.start_time || '-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="结束日期" width="140">
                    <template #default="{data}">
                        <span>{{data.end_time || '-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="备注" width="180">
                    <template #default="{data}">
                        <span>{{data.remark || '-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column
                        type="button"
                        label="操作"
                        width="120"
                        button-limit="2"
                >
                    <template #default="{data, index}">
                        <c-table-button v-if="getRecordStatus(data) !== 0" icon="tf-edit" @click="openPauseEdit(data)">编辑</c-table-button>
                        <c-table-button v-if="getRecordStatus(data) === 2" icon="tf-trash" @click="removePausePeriod(index)">删除</c-table-button>
                        <span v-if="getRecordStatus(data) === 0" style="color:#ccc">-</span>
                    </template>
                </c-table-column>
            </c-table>

            <!-- 临时支援网点设置 -->
            <c-title>临时支援</c-title>
            <div class="factory-handle flex">
                <c-button color="main" prepend-icon="tf-add" @click="openSupportEdit(null)">添加临时支援</c-button>
            </div>
            <c-table ref="supportTable" border :paging="false" :data="supportPeriods">
                <c-table-column label="序号" width="60">
                    <template #default="{index}">
                        <span>{{index + 1}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="状态" width="90">
                    <template #default="{data}">
                        <span class="status-tag" :class="'status-' + getRecordStatus(data)">{{recordStatusDic[getRecordStatus(data)]}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="支援网点" width="120">
                    <template #default="{data}">
                        <span>{{data.outlet_name || '-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="开始日期" width="120">
                    <template #default="{data}">
                        <span>{{data.start_time || '-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="结束日期" width="120">
                    <template #default="{data}">
                        <span>{{data.end_time || '-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="备注" width="150">
                    <template #default="{data}">
                        <span>{{data.remark || '-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column
                        type="button"
                        label="操作"
                        width="120"
                        button-limit="2"
                >
                    <template #default="{data, index}">
                        <c-table-button v-if="getRecordStatus(data) !== 0" icon="tf-edit" @click="openSupportEdit(data)">编辑</c-table-button>
                        <c-table-button v-if="getRecordStatus(data) === 2" icon="tf-trash" @click="removeSupportPeriod(index)">删除</c-table-button>
                        <span v-if="getRecordStatus(data) === 0" style="color:#ccc">-</span>
                    </template>
                </c-table-column>
            </c-table>
        </c-form>

        <!-- 暂停接单编辑弹框 -->
        <c-dialog ref="pauseEditDialog" width="450" @resolve="savePausePeriod">
            <c-form ref="pauseEditForm" vertical unit-width="100%">
                <c-form-item label="开始日期" required>
                    <c-datetime name="start_time" type="date" format="yyyy-MM-dd" placeholder="请选择开始日期"></c-datetime>
                </c-form-item>
                <c-form-item label="结束日期" required>
                    <c-datetime name="end_time" type="date" format="yyyy-MM-dd" placeholder="请选择结束日期"></c-datetime>
                </c-form-item>
                <c-form-item label="备注">
                    <c-input name="remark" type="textarea" maxlength="500" :rows="3" placeholder="备注说明（选填）"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>

        <!-- 临时支援编辑弹框 -->
        <c-dialog ref="supportEditDialog" width="500" @resolve="saveSupportPeriod">
            <c-form ref="supportEditForm" vertical unit-width="100%">
                <c-form-item label="支援网点" required>
                    <c-select
                            name="outlet_id"
                            async
                            @search="searchOutlet"
                            @change="handleOutletChange"
                            :value-data="supportEditData.outletOptions"
                            placeholder="请选择支援网点"
                    ></c-select>
                </c-form-item>
                <c-form-item label="开始日期" required>
                    <c-datetime name="start_time" type="date" format="yyyy-MM-dd" placeholder="请选择开始日期"></c-datetime>
                </c-form-item>
                <c-form-item label="结束日期" required>
                    <c-datetime name="end_time" type="date" format="yyyy-MM-dd" placeholder="请选择结束日期"></c-datetime>
                </c-form-item>
                <c-form-item label="备注">
                    <c-input name="remark" type="textarea" maxlength="500" :rows="3" placeholder="支援说明（选填）"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>
    </c-dialog>
</template>

<script>
export default {
    data() {
        return {
            userId: 0,
            pausePeriods: [],
            supportPeriods: [],
            pauseEditId: null,
            supportEditId: null,
            recordStatusDic: {
                0: '已失效',
                1: '生效中',
                2: '未开始'
            },
            pauseEditData: {
                start_time: '',
                end_time: '',
                remark: ''
            },
            supportEditData: {
                outlet_id: null,
                outletOptions: [],
                outlet_name: '',
                start_time: '',
                end_time: '',
                remark: ''
            }
        }
    },

    methods: {
        // 加载配置数据
        loadData() {
            if (!this.userId) return;
            this.request({
                url: '/engineer_receive_config/query',
                data: { engineer_id: this.userId },
                success: data => {
                    // 解析暂停接单时间段
                    this.pausePeriods = [];
                    if (data.pause_period_list && data.pause_period_list.length) {
                        this.pausePeriods = data.pause_period_list.map(item => ({
                            id: item.id,
                            start_time: item.start_time_str,
                            end_time: item.end_time_str,
                            remark: item.remark || ''
                        }));
                    }

                    // 解析临时支援时间段
                    this.supportPeriods = [];
                    if (data.support_period_list && data.support_period_list.length) {
                        this.supportPeriods = data.support_period_list.map(item => ({
                            id: item.id,
                            outlet_id: item.outlet_id,
                            outlet_name: item.outlet_name || '',
                            outletOptions: item.outlet_name ? [{ name: item.outlet_name, value: item.outlet_id }] : [],
                            start_time: item.start_time_str,
                            end_time: item.end_time_str,
                            remark: item.remark || ''
                        }));
                    }
                }
            });
        },

        async open(userId) {
            this.userId = userId;
            this.pausePeriods = [];
            this.supportPeriods = [];
            this.pauseEditId = null;
            this.supportEditId = null;
            this.$refs.form.clear();
            this.loadData();

            this.$refs.dialog.open({
                title: '自动接单设置'
            });
        },

        // 判断记录状态：0-已失效，1-生效中，2-未开始
        getRecordStatus(data) {
            // 使用日期字符串比较，避免时区问题
            var today = new Date();
            var todayStr = today.getFullYear() + '-' +
                String(today.getMonth() + 1).padStart(2, '0') + '-' +
                String(today.getDate()).padStart(2, '0');
            if (data.end_time && data.end_time < todayStr) return 0;  // 已失效
            if (data.start_time && data.start_time > todayStr) return 2;  // 未开始
            return 1;  // 生效中
        },

        // 打开暂停接单编辑弹框
        openPauseEdit(record) {
            this.pauseEditId = record ? record.id : null;
            this.$refs.pauseEditForm.clear();
            if (record) {
                this.$refs.pauseEditForm.set({
                    start_time: record.start_time,
                    end_time: record.end_time,
                    remark: record.remark
                });
            }
            this.$refs.pauseEditDialog.open({
                title: record ? '编辑暂停接单' : '添加暂停接单'
            });
        },

        // 保存暂停接单
        savePausePeriod(stop, next) {
            stop();
            const isEdit = !!this.pauseEditId;
            this.$refs.pauseEditForm.submit({
                url: isEdit ? '/engineer_receive_config/period/edit' : '/engineer_receive_config/period/add',
                rule: {
                    start_time: '请选择开始日期',
                    end_time: '请选择结束日期'
                },
                dataFormatter: formData => {
                    const data = {
                        engineer_id: this.userId,
                        period_type: 1,
                        start_time: formData.start_time,
                        end_time: formData.end_time,
                        remark: formData.remark
                    };
                    if (isEdit) {
                        data.id = this.pauseEditId;
                    }
                    return data;
                },
                success: () => {
                    this.pauseEditId = null;
                    next();
                    this.$message({
                        message: isEdit ? '暂停接单编辑成功' : '暂停接单添加成功',
                        type: 'success'
                    });
                    this.loadData();
                }
            });
        },

        // 删除暂停接单
        removePausePeriod(index) {
            const item = this.pausePeriods[index];
            this.$confirm({
                title: '确认删除',
                message: '删除未开始的暂停接单记录后，该时间段将不再影响自动派单，确认删除吗？',
                resolve: () => {
                    this.request({
                        url: '/engineer_receive_config/period/delete',
                        data: {
                            id: item.id
                        },
                        loading: true,
                        success: () => {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.loadData();
                        }
                    });
                }
            });
        },

        // 打开临时支援编辑弹框
        openSupportEdit(record) {
            this.supportEditId = record ? record.id : null;
            this.$refs.supportEditForm.clear();
            this.supportEditData.outletOptions = [];
            if (record) {
                this.supportEditData.outletOptions = record.outlet_name ? [{ name: record.outlet_name, value: record.outlet_id }] : [];
                this.$refs.supportEditForm.set({
                    outlet_id: record.outlet_id,
                    start_time: record.start_time,
                    end_time: record.end_time,
                    remark: record.remark
                });
            }
            this.$refs.supportEditDialog.open({
                title: record ? '编辑临时支援' : '添加临时支援'
            });
        },

        // 保存临时支援
        saveSupportPeriod(stop, next) {
            stop();
            const isEdit = !!this.supportEditId;
            this.$refs.supportEditForm.submit({
                url: isEdit ? '/engineer_receive_config/period/edit' : '/engineer_receive_config/period/add',
                rule: {
                    outlet_id: '请选择支援网点',
                    start_time: '请选择开始日期',
                    end_time: '请选择结束日期'
                },
                dataFormatter: formData => {
                    const data = {
                        engineer_id: this.userId,
                        period_type: 2,
                        outlet_id: formData.outlet_id,
                        start_time: formData.start_time,
                        end_time: formData.end_time,
                        remark: formData.remark
                    };
                    if (isEdit) {
                        data.id = this.supportEditId;
                    }
                    return data;
                },
                success: () => {
                    this.supportEditId = null;
                    next();
                    this.$message({
                        message: isEdit ? '临时支援编辑成功' : '临时支援添加成功',
                        type: 'success'
                    });
                    this.loadData();
                }
            });
        },

        // 删除临时支援
        removeSupportPeriod(index) {
            const item = this.supportPeriods[index];
            this.$confirm({
                title: '确认删除',
                message: '删除未开始的临时支援记录后，该时间段将不再影响自动派单，确认删除吗？',
                resolve: () => {
                    this.request({
                        url: '/engineer_receive_config/period/delete',
                        data: {
                            id: item.id
                        },
                        loading: true,
                        success: () => {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.loadData();
                        }
                    });
                }
            });
        },

        handleOutletChange(val) {
            if (val && typeof val === 'object') {
                this.supportEditData.outlet_id = val.value;
                this.supportEditData.outlet_name = val.name;
            }
        },

        searchOutlet(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'AFTERSALE_OUTLET',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            });
        },

        handleClose() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="stylus" scoped>
.form-tip
    display flex
    align-items center
    gap 6px
    padding 8px 12px
    border-radius 4px
    font-size 13px
    line-height 1.5

    &.warn-tip
        background #FFFBE6
        border 1px solid #FFE58F
        color #D48806

    &.info-tip
        background #E6F7FF
        border 1px solid #91D5FF
        color #0050B3

.status-tag
    display inline-block
    padding 2px 10px
    border-radius 10px
    font-size 12px
    line-height 20px

    &.status-0
        background #F5F5F5
        color #999

    &.status-1
        background #E6F7FF
        color #1890FF

    &.status-2
        background #F6FFED
        color #52C41A
</style>
